import React from "react"

export function fieldClassName({ compact = false, className = "" } = {}) {
  return ["ui-field", compact ? "ui-field--compact" : null, className].filter(Boolean).join(" ")
}

export const Field = React.forwardRef(function Field(
  { compact = false, className = "", as: Component = "input", ...props },
  ref
) {
  return <Component ref={ref} className={fieldClassName({ compact, className })} {...props} />
})

export default Field
